import { parseBackend } from "../backend"

/*
case class ChatConfig(configId: Option[Long],
                      username: String, // the PC user
                      user: String, // user for the LLM
                      password: String, // password for the LLM
                      host: String,
                     )
                      */
export interface ChatConfig {
    configId?: number
    username: string // the PC user
    user: string // user for the LLM
    password: string // password for the LLM
    host: string
    showTechnicalItems: boolean
}

interface ChatConfigManagement {
    config?: ChatConfig,
    username?: string,
    operation: 'get' | 'update'
}

// Super admin has to add username to retrieve for <username>. Otherwise it returns the config for the logged in user
export function get_config(username?: string) {
    return parseBackend(fetch('/api/management', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({operation: 'get', username, type: 'chat'} as ChatConfigManagement),
    })) //.then((c: ChatConfigManagement) => c.config)
}

export function update_config(config: ChatConfig) {
    return parseBackend(fetch('/api/management', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({operation: 'update', config, type: 'chat'} as ChatConfigManagement),
    }))
}

export function chat_config_key(username?: string) {
    return username ? ['chat-config', username] : ['chat-config']
}